import React, { useContext, useEffect, useRef, useState } from "react";
import { Dropdown, Modal, OverlayTrigger } from "react-bootstrap";
import { useTranslation, withTranslation } from "react-i18next";
import useFinalizeStatusPoller from "../../../../core/hooks/useFinalizeStatusPoller";
import { AiOutlineCalculator } from "react-icons/ai";
import {
  BiDotsHorizontalRounded,
  BiPencil,
  BiPlus,
  BiTrash,
  BiDownload,
  BiUpload,
  BiTransfer,
  BiGridVertical,
} from "react-icons/bi";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import RiskConfigService from "../../../../core/service/RiskConfigService";
import StandardService from "../../../../core/service/StandardService";
import ConfirmDialog from '../../../../core/utilities/ConfirmPopup';
import PermissionUtils from "../../../../core/utilities/PermissisonUtils";
import DataSourceLinker from "../../Datasource/DataSourceLinker";
import LinkDataSource from "../../RiskSettings/LinkDataSource/LinkDataSource";
import CreateDataPoint from "../CreateDataPoint/CreateDataPoint";
import EquationBuilder from "../EquationBuilder/EquationBuilder";
import "./DataPoints.scss";
import EmissionFactorLinker from "../../EmissionFactor/EmissionFactorLinker";
import LinkEmissionFactor from "../../RiskSettings/LinkEmissionFactor/LinkEmissionFactor";
import EmissionFactorService from "../../../../core/service/EmissionFactorService";
import ConfirmationModal from "../../../../components/ConfirmationModal/ConfirmationModal";
import CommonService from "../../../../core/service/CommonService";
import Utils from "../../../../core/utilities/Utils";
import useHasPermission from "../../../../core/hooks/useHasPermission";
import FinalizeProgressLoader from "../../../../components/FinalizeProgressLoader/FinalizeProgressLoader";
import EquationComponentsPopover from "../../../../components/EquationComponentsPopover/EquationComponentsPopover";
import MoveConfigurationModal, {
  MOVE_CONFIGURATION_TYPES,
} from "../../../../components/MoveConfigurationModal/MoveConfigurationModal";
import { LoaderContext } from "../../../../App";

const DataPoints = ({
  t
}) => {
  const { isFinalizeInProgress } = useFinalizeStatusPoller();
  const [metriclist, setMetricList] = useState([]);
  const [topicname, setTopicName] = useState("");
  const [addmetric, setAddMetric] = useState(false);
  const [editid, setEditId] = useState(false);
  const [show, setShow] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [messageConfirmation, setMessageConfirmation] = useState("");
  const [confirmId, setConfirmId] = useState("");
  let lsData = JSON.parse(localStorage.getItem("authority"));
  const [showequationbox, setShowEquationBox] = useState(false);
  const [equationDropdownOpen, setEquationDropdownOpen] = useState(false);
  const [equationObj, setEquationObj] = useState([]);
  const [data, setData] = useState([]);
  const { std_id } = useParams();
  const { topic_id } = useParams();
  const { metric_id } = useParams();
  const navigate = useNavigate();
  const [editdata, setEditData] = useState(null);
  const [editDataPointId, setEditDataPointId] = useState("");
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [showDataSource, setShowDataSource] = useState(true);
  const [selectedMetric, setSelectedMetric] = useState(null);
  const [selectedDataSource, setSelectedDataSource] = useState(null);
  const [uomList, setUOMList] = useState([]);

  const [showEmissionFactor, setShowEmissionFactor] = useState(false);
  const [showDS, setShowDS] = useState(false);
  const [showEF, setShowEF] = useState(false);
  const [selectedDP, setSelectedDP] = useState("");
  const [selectedEFId, setSelectedEFId] = useState("");
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [unlinkConfirmType, setUnlinkConfirmType] = useState("");
  const [selectedID, setSelectedID] = useState("");
  const [draggedDataPoint, setDraggedDataPoint] = useState(null);
  const [dragOverDataPointId, setDragOverDataPointId] = useState(null);
  const [isDragHandleActive, setIsDragHandleActive] = useState(false);
  const [selectedDataPointIds, setSelectedDataPointIds] = useState([]);
  const [showMoveModal, setShowMoveModal] = useState(false);
  const importFileRef = useRef(null);
  const { k, i18n } = useTranslation();
  const { hasConfigUpdatePermission } = useHasPermission();
  const { setLoaderDisplay } = useContext(LoaderContext);
  useEffect(() => {
    var lsDat = JSON.parse(localStorage.getItem('authority'));
    var equationDat = localStorage.getItem('equationData');
    if (equationDat && equationDat != null && equationDat !== undefined && equationDat != '' && equationDat !== 'undefined') {
      setEquationObj(JSON.parse(equationDat));
    }

    getDataPoints(metric_id);
    setSelectedDataPointIds([]);
  }, [metric_id]);

  useEffect(() => {
    const resetDragHandle = () => setIsDragHandleActive(false);
    window.addEventListener("mouseup", resetDragHandle);
    return () => window.removeEventListener("mouseup", resetDragHandle);
  }, []);

  const handleCallbackonfirmation = (val, id) => {
    setShow(false);
    if (id === 1) {
      // val && handleDeleteCallback(deleteId);
    }
  };

  const getDataPoints = (mId) => {
    StandardService.getDataPoints(mId)
      .then((response) => {
        const dataPoints = response?.data?.body?.dataPoints;
        if (Array.isArray(dataPoints)) {
          setData([...dataPoints].sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0)));
        } else {
          setData([]);
        }

      })
      .catch((error) => {
      });
  };
  const deleteDP = (id) => {
    setConfirmOpen(true);
    setDeleteId(id);
  };

  const deletConfirm = () => {
    StandardService.deleteDataPoint(deleteId)
      .then((response) => {
        if (response.status === 200) {
          toast.success("Success", {
            position: toast.POSITION.TOP_RIGHT,
          });
          getDataPoints(metric_id);
        }
      })
      .catch((error) => { });
  };
  const editDp = (item) => {
    setEditData(item);
    setEditDataPointId(item.id);
    handleShow();
    // let obj = {
    //   val: true,
    //   type: "DATAPOINT",
    //   id: id,
    //   metricId: metricId,
    //   data:item
    // };
    // handleEditDataPointCallback(obj);
  };
  const handleChildExpand = (id) => {
    // let obj = {
    //   action: "EXPAND",
    //   type: "METRIC",
    //   id: id,
    //   stdId: sId,
    // };
    // handleMetricChild(obj);
  };

  const addEquationBox = () => {
    setEquationDropdownOpen(false);
    if (!hasConfigUpdatePermission() || isFinalizeInProgress) {
      return;
    }
    setShowEquationBox(!showequationbox);
  }

  const updatedEquationObj = (obj) => {
    setEquationObj(obj);
  }

  const breadCrumbClick = (url) => {
    let urlMain = '';
    if (PermissionUtils.isSuperAdmin(lsData.roles)) {
      urlMain = '/admin' + url
    } else {
      urlMain = '/company_admin' + url
    }
    navigate(urlMain);
  }

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true)
  };
  const handleAfterSave = () => {
    // getTopics(std_id);
    handleClose();
    // setShowMetric(false);
  };

  const handleAfterDataPointSave = () => {
    getDataPoints(metric_id);
    handleClose();
  }

  const handleDataSourceLink = (metricId, dataSourceId = "") => {
    setSelectedMetric(metricId);
    setSelectedDataSource(dataSourceId);
    setShowDataSource(false);
    setShowDS(true);
    setShowEF(false);
  };

  const handleDataSourceUnlink = (itemId) => {
    RiskConfigService.unlinkDatasource(std_id, itemId, 'dataPoint')
      .then((response) => {
        if (response.status === 200) {
          toast.success("Success", {
            position: toast.POSITION.TOP_RIGHT,
          });
          setSelectedID('');
          getDataPoints(metric_id);
        }
      }).catch((error) => { });
  };

  const handleEmissionFactorLink = (dpId, emissionFactorId = "") => {
    setSelectedDP(dpId);
    setSelectedEFId(emissionFactorId);
    setShowDataSource(false);
    setShowDS(false);
    setShowEF(true);
  };

  const confirmDelete = (val) => {
    setShowConfirmation(false);
    if (val) {
      if (unlinkConfirmType == 'em') {
        handleEmissionFactorUnlink(selectedID);
      } else if (unlinkConfirmType == 'ds') {
        handleDataSourceUnlink(selectedID);
      }
    }
  };

  const showConfirm = (id, confirmType) => {
    setSelectedID(id)
    setShowConfirmation(true);
    setUnlinkConfirmType(confirmType);
  }

  const handleEmissionFactorUnlink = (dpId) => {
    EmissionFactorService.unlinkEmissionFactorDP(dpId).then(res => {
      if (res.status === 200) {
        toast.success("Success", {
          position: toast.POSITION.TOP_RIGHT,
        });
        setSelectedID('');
        getDataPoints(metric_id);
      }
    }).catch(err => { });
  };

  const handleDataSourceCallback = (val) => {
    setShowDataSource(true);
    setShowDS(false);
    setShowEF(false);
    getDataPoints(metric_id);
    setUnlinkConfirmType('');
  };

  const handleEFCallback = (val) => {
    setShowDataSource(true);
    setShowDS(false);
    setShowEF(false);
    setSelectedDP('');
    setSelectedEFId('');
    getDataPoints(metric_id);
    setUnlinkConfirmType('');
  };

  useEffect(() => {
    StandardService.getUnitsOfMeasure()
      .then((response) => {
        if (response.status !== 200) return;

        // setUOMList(response.data.data);
        const outputList = []
        for (let index = 0; index < response.data.data.length; index++) {
          const element = response.data.data[index];
          outputList.push({
            label: "outputUnit",
            value: element.outputUnit
          });
        }
        const uniqueArray = Array.from(new Set(outputList.map(obj => obj.value))).map(
          value => outputList.find(obj => obj.value === value)
        );
        uniqueArray.sort((a, b) => a.value.localeCompare(b.value));
        setUOMList(uniqueArray);
      })
      .catch((error) => { });
  }, []);

  const getTableData = (item) => {
    const updatedData = CommonService.changeFieldNameByi18n(item, i18n.language);
    return updatedData;
  }

  const handleEmissionDPSave = () => {
    getDataPoints(metric_id)
  }

  const canReorderDataPoints = () =>
    hasConfigUpdatePermission() && !isFinalizeInProgress;

  const reorderDataPointsLocally = (dataPoints, draggedId, movedToId) => {
    const moved = dataPoints.find(dp => dp.id === draggedId);
    if (!moved) return dataPoints;

    const updated = dataPoints.filter(dp => dp.id !== draggedId);
    const targetIndex = updated.findIndex(dp => dp.id === movedToId);
    updated.splice(targetIndex + 1, 0, moved);
    return updated;
  };

  const onDataPointDragHandleMouseDown = () => {
    setIsDragHandleActive(true);
  };

  const onDataPointDragStart = (dataPoint) => {
    setDraggedDataPoint(dataPoint);
  };

  const onDataPointDragOver = (e, dataPointId) => {
    e.preventDefault();
    setDragOverDataPointId(dataPointId);
  };

  const onDataPointDragEnd = () => {
    setIsDragHandleActive(false);
    if (!draggedDataPoint || !dragOverDataPointId || draggedDataPoint.id === dragOverDataPointId) {
      setDraggedDataPoint(null);
      setDragOverDataPointId(null);
      return;
    }

    const reordered = reorderDataPointsLocally(data, draggedDataPoint.id, dragOverDataPointId);
    setData(reordered);

    StandardService.reorderDataPoint(draggedDataPoint.id, { movedToId: dragOverDataPointId })
      .finally(() => getDataPoints(metric_id));

    setDraggedDataPoint(null);
    setDragOverDataPointId(null);
  };

  const isDataPointDragTarget = (item) =>
    canReorderDataPoints()
    && dragOverDataPointId === item.id
    && draggedDataPoint?.id !== item.id;

  const isDataPointDragging = (item) =>
    canReorderDataPoints() && draggedDataPoint?.id === item.id;

  const canManageDataPointExportImport = () =>
    hasConfigUpdatePermission() && !isFinalizeInProgress;

  const areAllDataPointsSelected = () =>
    data.length > 0 && data.every(dp => selectedDataPointIds.includes(dp.id));

  const toggleDataPointSelection = (dataPointId) => {
    setSelectedDataPointIds(prev =>
      prev.includes(dataPointId) ? prev.filter(id => id !== dataPointId) : [...prev, dataPointId]
    );
  };

  const toggleSelectAllDataPoints = () => {
    if (areAllDataPointsSelected()) {
      setSelectedDataPointIds([]);
    } else {
      setSelectedDataPointIds(data.map(dp => dp.id));
    }
  };

  const downloadExcelFile = (response, fileName) => {
    const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const fileURL = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = fileURL;
    link.download = fileName;
    link.click();
    link.remove();
    window.URL.revokeObjectURL(fileURL);
  };

  const handleExportDataPoints = () => {
    if (!std_id || selectedDataPointIds.length === 0) return;

    StandardService.exportDataPoints(std_id, { dataPointIds: selectedDataPointIds })
      .then((response) => {
        downloadExcelFile(response, `datapoints_export_${metric_id}.xlsx`);
      })
      .catch(() => { });
  };

  const handleImportDataPointsClick = () => {
    importFileRef.current?.click();
  };

  const handleImportDataPointsFile = (e) => {
    const file = e.target.files?.[0];
    if (!file || !std_id || !metric_id) return;

    const formData = new FormData();
    formData.append("file", file);

    setLoaderDisplay(true);
    StandardService.importDataPoints(std_id, metric_id, formData)
      .then((response) => {
        if (response.status === 200) {
          Utils.showImportResultToast(t, response.data);
          setSelectedDataPointIds([]);
          getDataPoints(metric_id);
        }
      })
      .catch(() => { })
      .finally(() => {
        setLoaderDisplay(false);
        e.target.value = "";
      });
  };

  return (
    <>
      {/* <div className='Breadcrumb_box py-2'>
        <Breadcrumb className="h6">
          <Breadcrumb.Item onClick={() => breadCrumbClick('/standard')}>{t("Configurations.label")} </Breadcrumb.Item>
          <Breadcrumb.Item onClick={() => breadCrumbClick('/topiclist/' + std_id)}>{localStorage.getItem('standardName')} </Breadcrumb.Item>
          <Breadcrumb.Item onClick={() => breadCrumbClick('/metriclist/' + std_id + '/' + topic_id)}>{localStorage.getItem('topicName')} </Breadcrumb.Item>
          <Breadcrumb.Item active>{localStorage.getItem('metricName')}</Breadcrumb.Item>
        </Breadcrumb>
      </div> */}
      <div className="List_header pb-2">
        <h5 className="MH m-0">{t("Configurations.label")}</h5>
      </div>
      <div className="Topics_headeView">
        <ul>
          <li>
            Standard : <b>{localStorage.getItem('standardName')}</b>
          </li>
          <li>
            Category : <b>{localStorage.getItem('categoryName')}</b>
          </li>
          <li>
            Topic : <b>{localStorage.getItem('topicName')}</b>
          </li>
          <li>
            Metric : <b>{localStorage.getItem('metricName')}</b>
          </li>
          <li>

          </li>
          <li>
            <span className="me-2">Equation : </span>
            <div className="d-flex align-items-center flex-wrap">
              <div className="AddEquation_box 2 d-inline-block align-middle">
                <Dropdown
                  show={equationDropdownOpen}
                  onToggle={setEquationDropdownOpen}
                  autoClose={false}
                >
                  <Dropdown.Toggle variant="ShowEquation" id="equation-builder-dropdown-toggle">

                    <AiOutlineCalculator className="me-2" /> {equationObj != undefined && (equationObj.expression)
                      ? <>{equationObj.expression}</>
                      : <> Add Equation</>}
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="p-0">
                    <EquationBuilder
                      stdId={std_id}
                      metricId={metric_id}
                      topicId={topic_id}
                      discardBtnClick={addEquationBox}
                      equationObj={equationObj}
                      updatedEquationObj={updatedEquationObj}
                    />
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              {equationObj && equationObj.expression && equationObj.expressionWithId && (
                <EquationComponentsPopover
                  standardId={std_id}
                  equationId={equationObj.expressionWithId}
                  headerText={equationObj.expression}
                  popoverKey={`config-dp-metric-${metric_id}`}
                  className="cursor text-success ms-1 align-middle"
                  popoverClassName="equation-components-popover--wide"
                  iconSize={16}
                  dataPoints={data}
                />
              )}
            </div>
            {/* <div className={`ShowEquation_box cursor ${isFinalizeInProgress ? 'disabled-icon' : ''}`} onClick={addEquationBox}>

                <AiOutlineCalculator className="me-2" /> {equationObj != undefined && (equationObj.expression)
                  ? <>{equationObj.expression}</>
                  : <> Add Equation</>}
              </div>

              {showequationbox && (
                <EquationBuilder
                  stdId={std_id}
                  metricId={metric_id}
                  topicId={topic_id}
                  discardBtnClick={addEquationBox}
                  equationObj={equationObj}
                  updatedEquationObj={updatedEquationObj}
                />
              )} */}
          </li>
          {/* <li>
            Equation : <b><div className="AddEquation_box 3">
              <span className="cursor" onClick={addEquationBox}>

                <AiOutlineCalculator className="me-2" /> {equationObj != undefined && (equationObj.expression)
                  ? <>{equationObj.expression}</>
                  : <> Add Equation</>}
              </span>

              {showequationbox && (
                <EquationBuilder
                  stdId={std_id}
                  metricId={metric_id}
                  topicId={topic_id}
                  discardBtnClick={addEquationBox}
                  equationObj={equationObj}
                  updatedEquationObj={updatedEquationObj}
                />
              )}
            </div></b>
          </li> */}
        </ul>
        {
          !showDS && !showEF &&
          <div className="btn-custom p-1 text-end d-flex align-items-center justify-content-end gap-2">
            {canManageDataPointExportImport() && (
              <>
                <OverlayTrigger overlay={Utils.renderTooltip(t("Import.label"))}>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleImportDataPointsClick}
                    aria-label={t("Import.label")}
                  >
                    <BiUpload className="me-1" />
                    {t("Import.label")}
                  </button>
                </OverlayTrigger>
                <input
                  ref={importFileRef}
                  type="file"
                  className="d-none"
                  accept=".xlsx,.xls"
                  onChange={handleImportDataPointsFile}
                />
                {selectedDataPointIds.length > 0 && (
                  <>
                    <OverlayTrigger overlay={Utils.renderTooltip(t("Export.label"))}>
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleExportDataPoints}
                        aria-label={t("Export.label")}
                      >
                        <BiDownload className="me-1" />
                        {t("Export.label")} ({selectedDataPointIds.length})
                      </button>
                    </OverlayTrigger>
                    <OverlayTrigger overlay={Utils.renderTooltip(t("DataPoints.moveTo.label"))}>
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => setShowMoveModal(true)}
                        aria-label={t("DataPoints.moveTo.label")}
                      >
                        <BiTransfer className="me-1" />
                        {t("DataPoints.moveTo.label")}
                      </button>
                    </OverlayTrigger>
                  </>
                )}
              </>
            )}
            <button
              className="btn btn-secondary"
              onClick={() => breadCrumbClick('/metriclist/' + std_id + '/' + topic_id)}
            >
              {t("Back.label")}
            </button>
          </div>
        }
      </div>
      <FinalizeProgressLoader isFinalizeInProgress={isFinalizeInProgress} />

      {
        showDataSource &&
        <div className=" SL_Datapoints_card">
          <div className="SL_Datapoints_card_body p-0">
            {data.length > 0 && canManageDataPointExportImport() && (
              <div className="row m-0 mb-2">
                <div className="col-auto p-1 d-flex align-items-center">
                  <input
                    className="form-check-input me-2"
                    type="checkbox"
                    id="select-all-datapoints"
                    checked={areAllDataPointsSelected()}
                    onChange={toggleSelectAllDataPoints}
                  />
                  <label className="form-check-label" htmlFor="select-all-datapoints">
                    {t("SelectAll.label")}
                  </label>
                </div>
              </div>
            )}
            {data.length > 0 && (getTableData(data))?.map((item) => (
              <div
                className={`card SL_Datapoints_card_body_inner${isDataPointDragTarget(item) ? ' standards-drop-target' : ''}${isDataPointDragging(item) ? ' opacity-50' : ''}`}
                key={item.id}
                draggable={canReorderDataPoints() && isDragHandleActive}
                onDragStart={() => onDataPointDragStart(item)}
                onDragOver={(e) => canReorderDataPoints() && onDataPointDragOver(e, item.id)}
                onDragEnd={onDataPointDragEnd}
              >
                <div className="card-body px-2 py-1">
                  <div className="row m-0">
                    <div
                      className="col-auto p-1 data-point-drag-handle"
                      onMouseDown={() => canReorderDataPoints() && onDataPointDragHandleMouseDown()}
                    >
                      <BiGridVertical />
                    </div>

                    <div className="col-lg-11 p-0 1">
                      <div className="row m-0 align-items-center">
                        {canManageDataPointExportImport() && (
                          <div className="col-auto p-2 d-flex align-items-center">
                            <input
                              className="form-check-input m-0"
                              type="checkbox"
                              checked={selectedDataPointIds.includes(item.id)}
                              onChange={() => toggleDataPointSelection(item.id)}
                              onClick={(e) => e.stopPropagation()}
                            />
                          </div>
                        )}
                        <div className="col-lg-3 p-2 datapoint-name-cell">
                          <h6 className="mb-0 datapoint-name">{item.name}</h6>
                          <div className="d-flex align-items-center mt-1">
                            {item.applicable === false && (
                              <span className="badge datapoint-not-applicable-badge">
                                {t("NotApplicable.label")}
                              </span>
                            )}
                            <span className={`badge ${item.emission ? "bg-success" : "bg-danger"} ms-1`}>
                              {t("Emission.label")} {t(item.emission ? "Enabled.label" : "Disabled.label")}
                            </span>
                          </div>
                        </div>
                        <div className="col-lg-2 col-md-4 p-2">
                          <ul className="SL_Datapoints_inner_ul">
                            <li>
                              <p className="mb-0">{t("MeasuringUnit.label")} : </p>
                              <h6 className="mb-0">{item.unitOfMeasure}</h6>
                            </li>
                          </ul>
                        </div>
                        <div className="col-lg-2 col-md-4 p-2">
                          <ul>
                            <li>
                              <p className="mb-0">{t("Code.label")} : </p>
                              <h6 className="mb-0">{item.code}</h6>
                            </li>
                          </ul>
                        </div>
                        <div className="col-lg-2 col-md-4 p-2">
                          <ul className="d-flex align-items-center">
                            <DataSourceLinker item={item}
                              openDataSourceLink={(itemId, dataSourceId) => {
                                if (isFinalizeInProgress) return;
                                handleDataSourceLink(itemId, dataSourceId);
                              }}
                              unlinkDataSource={(item) => {
                                if (isFinalizeInProgress) return;
                                showConfirm(item.id, 'ds');
                              }}
                              disabled={isFinalizeInProgress} />
                          </ul>
                        </div>
                        <div className="col-lg-2 col-md-4 p-2">
                          <ul className="d-flex align-items-center">
                            <EmissionFactorLinker item={item}
                              fromDataPointPage={true}
                              onSaveSuccess={handleEmissionDPSave}
                              openEmissionFactorLink={(itemId, emissionFactorId) => {
                                if (isFinalizeInProgress) return;
                                handleEmissionFactorLink(itemId, emissionFactorId);
                              }}
                              unlinkEmissionFactor={(dpId) => {
                                if (isFinalizeInProgress) return;
                                showConfirm(dpId, 'em');
                              }}
                              disabled={isFinalizeInProgress} />
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="edit_btn-absolute">
                    {
                      item?.mandatory === true ? (
                        ""
                      ) : (
                        <Dropdown hidden={!hasConfigUpdatePermission() || isFinalizeInProgress}>
                          <Dropdown.Toggle variant="blank_outline" id="dropdown-basic" disabled={isFinalizeInProgress}>
                            <BiDotsHorizontalRounded />
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Item
                              href="#"
                              onClick={() => {
                                if (isFinalizeInProgress) return;
                                setEditDataPointId(null);
                                editDp(item)
                              }}
                              className={isFinalizeInProgress ? 'disabled-icon' : ''}
                              disabled={isFinalizeInProgress}>
                              <BiPencil /> {t("Edit.label")}
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() => {
                              if (isFinalizeInProgress) return;
                              deleteDP(item.id);
                            }} className={isFinalizeInProgress ? 'disabled-icon' : ''} disabled={isFinalizeInProgress}>
                              <BiTrash /> {t("Delete.label")}
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      )}
                  </div>
                </div>
              </div>
            ))}
            <div className="col-lg-12 p-1" hidden={!hasConfigUpdatePermission() || isFinalizeInProgress}>
              <button className={`btn btn-primary me-2 ${isFinalizeInProgress ? 'disabled-icon' : ''}`} onClick={() => {
                if (isFinalizeInProgress) return;
                setEditDataPointId(null)
                handleShow()
              }} disabled={isFinalizeInProgress}>
                <BiPlus className="me-2"> </BiPlus>
                {t("DataPoint.label")}
              </button>
              {/* <button className="btn btn-secondary" >
                        <BiPlus className="me-2"> </BiPlus>
                        {t("Topic.label")}
                      </button> */}
            </div>

          </div>

        </div>
      }

      {
        showDS &&
        <LinkDataSource
          regulation={std_id}
          paramId={selectedMetric}
          dsId={selectedDataSource}
          handleDataSourceCallback={handleDataSourceCallback}
          configType={'KPI'}
          paramType={'dataPoint'}
        />
      }

      {
        showEF &&
        <LinkEmissionFactor
          dataPointId={selectedDP}
          handleEFCallback={handleEFCallback}
          linkType={'dp'}
        />
      }
      <Modal size="lg" show={show} onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title as="h5">
            {/* Add Datapoint */}
            {editDataPointId ? t("EditDataPoint.label") : t("AddDataPoint.label")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <CreateDataPoint
            handleDiscard={handleClose}
            metricId={metric_id}
            editDataPointId={editDataPointId}
            handleSave={handleAfterDataPointSave}
            editData={editdata}
          />
        </Modal.Body>
      </Modal>

      <MoveConfigurationModal
        show={showMoveModal}
        onHide={() => setShowMoveModal(false)}
        moveType={MOVE_CONFIGURATION_TYPES.DATAPOINTS_TO_METRIC}
        standardId={std_id}
        selectedIds={selectedDataPointIds}
        sourceName={localStorage.getItem("metricName") || ""}
        excludeMetricId={metric_id}
        onMoveSuccess={() => {
          setSelectedDataPointIds([]);
          getDataPoints(metric_id);
        }}
      />

      {deleteId && <ConfirmDialog
        open={confirmOpen}
        setOpen={setConfirmOpen}
        onConfirm={deletConfirm}>
        <div className='text-center'>{t("ConfirmDelete.label")}</div>
      </ConfirmDialog>}

      {showConfirmation && (
        <ConfirmationModal
          modalShow={true}
          messageText={t("UnlinkEmissionFactorConfirmation.label")}
          callbackModal={confirmDelete}
          confirmBtn={t("Confirm.label")}
          CancelBtn={t("Cancel.label")}
        />
      )}
    </>
  );
};

export default withTranslation()(DataPoints);
